import React from "react";
import styled from "styled-components";
import { useTranslation } from "@coworker/locales";
import { Article } from "../types/article";
import { Text } from "../Atoms/Text";
import { FurnitureSetWrapper } from "../Atoms/FurnitureSetWrapper";
import FurnitureSet from "../../../../../coworker-app/src/assets/svg/furniture-set.svg";
import { FixaProductIdentifier } from "@coworker/apprestructured/src/shared/wrappers/FixaProductIdentifier/FixaProductIdentifier";
import { formatFullIdWithDots } from "@coworker/reusable/formatters/product.formatter";

const LocalCombinationSubArticlePanelContainer = styled("div")<{
  $noBorderBottom?: boolean;
}>`
  display: flex;
  align-items: center;
  padding: 12px 0 12px 24px;
  white-space: pre-line;
  border-bottom: ${({ $noBorderBottom }) =>
    $noBorderBottom ? "none" : "1px solid var(--grey200)"};
`;

const StyledListImage = styled("div")``;

const TextContainer = styled("div")`
  margin-left: 16px;
`;

interface LocalCombinationSubArticlePanelProps {
  parentArticle: Article | undefined;
  noBorderBottom?: boolean;
}

const LocalCombinationSubArticlePanel: React.FC<
  LocalCombinationSubArticlePanelProps
> = ({ parentArticle, noBorderBottom = false }) => {
  const { t } = useTranslation();

  if (!parentArticle) return null;

  return (
    <LocalCombinationSubArticlePanelContainer $noBorderBottom={noBorderBottom}>
      <StyledListImage>
        <FurnitureSetWrapper>
          <img
            src={FurnitureSet}
            alt="Furniture Set"
            style={{ width: "24px", height: "24px" }}
          />
        </FurnitureSetWrapper>
      </StyledListImage>
      <TextContainer>
        <Text
          text={t("localCombinationSubArticlePanelString")}
          bold={false}
          grey={true}
        />
        <Text text={` ${parentArticle.itemName}`} bold={true} />
        <FixaProductIdentifier
          value={formatFullIdWithDots(parentArticle.productArticleId)}
        />
      </TextContainer>
    </LocalCombinationSubArticlePanelContainer>
  );
};

export default LocalCombinationSubArticlePanel;
